<script lang="ts">
    import MainLayout from '../#common/layout/Layout.svelte'
    import Intro from 'src/components/main/home/components/intro/Intro.svelte'
    import Utility from 'src/components/main/home/components/utility/Utility.svelte'
    import Anatomy from 'src/components/main/home/components/anatomy/Anatomy.svelte'
    import Tokenomics from 'src/components/main/home/components/tokenomics/Tokenomics.svelte'
    import Advisors from 'src/components/main/home/components/advisors/Advisors.svelte'
    import MintComing from 'src/components/main/home/components/mint-coming/MintComing.svelte'
    import Contact from 'src/components/main/home/components/contact/Contact.svelte'
</script>

<svelte:head>
    <title>Realis: Unifying NFT and gaming utility</title>
    <meta name="description" content="Realis is the world's first platform for launching mobile games for a mass audience with the integration of Blockchain, Defi and NFT components"/>
</svelte:head>

<MainLayout home={true}>
    <svelte:fragment slot="content">
        <Intro/>
        <Utility/>
        <Anatomy/>
        <Tokenomics/>
        <Advisors/>
        <MintComing/>
        <Contact/>
    </svelte:fragment>
</MainLayout>
